import React from "react";
import { useLang } from "../../context/LangContext";
import { useCMS } from "../../context/CMSContext";
import Icon from "../common/Icon"; // ← use real Icon
import styles from "./Features.module.css";


export default function Features() {
  const { lang } = useLang();
  const { cms } = useCMS();

  const items = cms?.features?.items ?? [];
  if (items.length === 0) return null;

  return (
    <section id="features" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          {lang === "tr" ? "Neden Bitakas?" : "Why Bitakas?"}
        </h2>
        <p className={styles.sub}>
          {lang === "tr"
            ? "Takas deneyimini yeniden tanımlayan özellikler."
            : "Features that redefine the trading experience."}
        </p>
        <div className={styles.grid}>
          {items.map((f) => (
            <div key={f.id} className={styles.card}>
              {f.icon && (
                <div className={styles.iconWrap}>
                  <Icon name={f.icon} size={28} color="#D60B0B" />
                </div>
              )}
              <h3 className={styles.title}>
                {f[`title_${lang}`] || f.title_en}
              </h3>
              <p className={styles.desc}>{f[`desc_${lang}`] || f.desc_en}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
